<template lang="pug"></template>

<script>
import BotaoGestaoOperacoes from '@/components/botoesMenu/BotaoGestaoOperacoes';
import BotaoFiscalizacaoOperacoes from '@/components/botoesMenu/BotaoFiscalizacaoOperacoes';
import BotaoDashboardOperacoes from '@/components/botoesMenu/BotaoDashboardOperacoes.vue';
import BotaoDashboardMonitoramentoOperacoes from '@/components/botoesMenu/BotaoDashboardMonitoramentoOperacoes.vue';

export default {
    name: 'BotaoOperacao',
    componentOptions: {
        title: 'Operação',
        actions: [
            [
                {
                    name: 'Operação',
                    iconClass: 'lyra-icon lyra-money-alt',
                    showView: false,
                    action: 'abrirOperacoes',
                    route: 'operacao',
                    submenus: [
                        BotaoGestaoOperacoes,
                        BotaoFiscalizacaoOperacoes,
                        BotaoDashboardOperacoes,
                        BotaoDashboardMonitoramentoOperacoes
                    ]
                }
            ]
        ]
    },

    methods: {
        abrirOperacoes() {
            if (this.$route.name !== 'operacao') {
                this.$router.push({ name: 'operacao' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
